import { createStyles, makeStyles } from '@hawkins/styles';
export function formGroupStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the root element. */
        root: {
            display: 'flex',
        },
        /** Class name of the root element when the component is full width. */
        rootFullWidth: {
            width: '100%',
        },
        /** Class name of the root element when the component is oriented horizontally. */
        rootHorizontal: {
            gap: hawkinsVariables.spacings.space2,
        },
        /** Class name of the root element when the component is oriented vertically. */
        rootVertical: {
            flexDirection: 'column',
            gap: hawkinsVariables.spacings.space5,
        },
    });
}
export var useFormGroupStyles = makeStyles(formGroupStyles, { name: 'Hawkins-FormGroup' });
